var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "mb-3" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-8 offset-md-2 col-12" }, [
        _c("div", { staticClass: "card" }, [
          _c("div", { staticClass: "card-body shadow-sm" }, [
            _c("h2", { staticClass: "text-center mt-2" }, [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.$t("message.scope_of_service")) +
                  "\n          "
              )
            ]),
            _vm._v(" "),
            _c("div", {
              staticClass: "p-2",
              domProps: {
                innerHTML: _vm._s(
                  _vm.$i18n.locale === "th"
                    ? _vm.globalState.services[_vm.parentServiceId].detail_th
                    : _vm.globalState.services[_vm.parentServiceId].detail_en
                )
              }
            })
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-05517393", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05517393","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/booking/components/ServiceDetail.vue
// module id = 1866
// module chunks = 0